import React from "react"
import PropTypes from "prop-types"
import Helmet from "react-helmet"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage, getSrc } from "gatsby-plugin-image"
import useSiteMetadata from "../hooks/useSiteMetadata"

const Seo = ({
	keywords = "",
	description = "",
	lang = "en",
	meta = [],
	title,
	ogImage = null,
	ogImageUrl = null,
}) => {
	const siteMetadata = useSiteMetadata()

	const metaTitle = title || siteMetadata.title
	const metaDescription = description || siteMetadata.description

	const data = useStaticQuery(graphql`
		query OGImageQuery {
			ogImage: file(relativePath: { eq: "og-cloud-fleet-manager.png" }) {
				childImageSharp {
					gatsbyImageData(layout: FIXED, width: 1200, height: 630, formats: [JPG])
				}
			}
		}
	`)

	var ogImageSrc = `${siteMetadata.siteUrl}${getSrc(getImage(data.ogImage))}`

	if (ogImage) {
		ogImageSrc = `${siteMetadata.siteUrl}${getSrc(getImage(ogImage))}`
	}

	if (ogImageUrl) {
		ogImageSrc = ogImageUrl
	}

	return (
		<Helmet
			htmlAttributes={{
				lang,
			}}
			bodyAttributes={{
				class: "antialiased",
			}}
			title={metaTitle}
			titleTemplate={`%s`}
			meta={[
				{
					name: `description`,
					content: metaDescription,
				},
				{
					name: `keywords`,
					content: keywords,
				},
				{
					property: `og:title`,
					content: metaTitle,
				},
				{
					property: `og:description`,
					content: metaDescription,
				},
				{
					property: `og:type`,
					content: `website`,
				},
				{
					property: `og:image`,
					content: ogImageSrc,
				},
				{
					name: `twitter:image`,
					content: ogImageSrc,
				},
				{
					name: `twitter:card`,
					content: `summary_large_image`,
				},
				{
					name: `twitter:creator`,
					content: siteMetadata.twitter,
				},
				{
					name: `twitter:title`,
					content: metaTitle,
				},
				{
					name: `twitter:description`,
					content: metaDescription,
				},
				{
					property: `viewport`,
					content: `width=device-width, initial-scale=1.0, viewport-fit=cover`,
				},
			].concat(meta)}
		/>
	)
}

Seo.propTypes = {
	title: PropTypes.string.isRequired,
	description: PropTypes.string,
	ogImage: PropTypes.object,
	ogImageUrl: PropTypes.string,
	lang: PropTypes.string,
	meta: PropTypes.arrayOf(PropTypes.object),
}

export default Seo
